import { LogoMark, Wordmark } from "./Logo";

export const Footer = () => (
  <footer
    className="border-t border-dealer-ivory/10 py-16 sm:py-20"
    data-testid="site-footer"
  >
    <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
      <div className="flex flex-col items-start justify-between gap-12 md:flex-row md:items-center">
        <div className="flex items-center gap-4">
          <LogoMark size={44} />
          <div>
            <Wordmark className="text-xl" />
            <p className="mt-2 font-sans text-[10px] font-medium tracking-[0.2em] text-dealer-subtle">
              MANAGEMENT &middot; STRATEGY &middot; VENTURES
            </p>
          </div>
        </div>

        <nav className="flex flex-col items-start gap-5 sm:flex-row sm:items-center sm:gap-10" aria-label="Contact">
          <a
            href="mailto:asu@dealermgt.com"
            data-testid="footer-link-email"
            className="font-sans text-[11px] font-medium tracking-[0.25em] text-dealer-silver transition-colors duration-300 hover:text-dealer-ivory"
          >
            ASU@DEALERMGT.COM
          </a>
          <a
            href="https://instagram.com/dealermgt"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-link-instagram"
            className="font-sans text-[11px] font-medium tracking-[0.25em] text-dealer-silver transition-colors duration-300 hover:text-dealer-ivory"
          >
            INSTAGRAM&nbsp;@DEALERMGT
          </a>
        </nav>
      </div>

      <div className="dealer-rule mt-14" />
      <p className="mt-8 font-sans text-[10px] tracking-[0.25em] text-dealer-subtle">
        &copy; 2026 DEALER MANAGEMENT
      </p>
    </div>
  </footer>
);
